import { lazy, Suspense, useEffect } from 'react';
import { AuthProvider } from './auth/AuthProvider';
import { useAuth } from './auth/useAuth';
import { navigate, usePathname } from './hooks/usePathname';
import { CapturePage } from './pages/CapturePage';
import { ConfigurationPage } from './pages/ConfigurationPage';
import { LoginPage } from './pages/LoginPage';

const InboxPage = lazy(() =>
  import('./pages/InboxPage').then((module) => ({ default: module.InboxPage })),
);

const WorkspacePage = lazy(() =>
  import('./pages/WorkspacePage').then((module) => ({ default: module.WorkspacePage })),
);

const DemoAPage = lazy(() =>
  import('./pages/InteractionDemos').then((module) => ({ default: module.DemoAPage })),
);

const DemoBPage = lazy(() =>
  import('./pages/InteractionDemos').then((module) => ({ default: module.DemoBPage })),
);

const DemoCPage = lazy(() =>
  import('./pages/InteractionDemos').then((module) => ({ default: module.DemoCPage })),
);

const DemoDPage = lazy(() =>
  import('./pages/IntegratedExperienceDemo').then((module) => ({ default: module.IntegratedExperienceDemo })),
);

function Router() {
  const { configured, loading, session } = useAuth();
  const pathname = usePathname();

  useEffect(() => {
    if (pathname === '/') navigate('/capture', true);
  }, [pathname]);

  if (pathname === '/demo-a' || pathname === '/demo-b' || pathname === '/demo-c' || pathname === '/demo-d') {
    return (
      <Suspense fallback={<main className="loading-page"><span>正在打开交互 Demo</span></main>}>
        {pathname === '/demo-a' ? <DemoAPage /> : pathname === '/demo-b' ? <DemoBPage /> : pathname === '/demo-c' ? <DemoCPage /> : <DemoDPage />}
      </Suspense>
    );
  }

  if (!configured) return <ConfigurationPage />;
  if (loading) return <main className="loading-page"><span>正在打开收件箱</span></main>;
  if (!session) return <LoginPage />;
  if (pathname === '/app') {
    return (
      <Suspense fallback={<main className="loading-page"><span>正在打开个人工作区</span></main>}>
        <WorkspacePage />
      </Suspense>
    );
  }
  if (pathname === '/inbox') {
    return (
      <Suspense fallback={<main className="loading-page"><span>正在打开收件箱</span></main>}>
        <InboxPage />
      </Suspense>
    );
  }
  return <CapturePage />;
}

export function App() {
  return (
    <AuthProvider>
      <Router />
    </AuthProvider>
  );
}
